// extracted by mini-css-extract-plugin
export default {"page":"jO","freeShippingContainer":"kO","customizeContainer":"lO","customizeHeader":"mO","fadein":"nO","customizeText":"oO","hidden":"pO","productcard":"qO","accordeonscontainer":"rO","freeShipping":"sO","mainpart":"tO"};
    if(module.hot) {
      // 1714422956862
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  